// extracted by mini-css-extract-plugin
export default {"icon":"Close_icon__QRSzC"};